import Image from "next/image";

const LoanFeatures = ({ loanFeaturesData }) => {
  return (
    <section className="bg-[#F0F7FF] py-[100px] sm:py-20">
      <div className="mx-auto text-center sm:px-3">
        <h2 className="text-heading5 sm:text-3xl font-medium text-baseBlack mb-4">
          {loanFeaturesData.title}
        </h2>

        <div className="bg-[#FFFAED] mt-8 rounded-xl shadow-sm p-5 sm:p-2 lg:w-3/5 xl:w-2/4 md:w-4/6 sm:w-full m-auto border border-[#F9ECCD]">
          <div className="flex flex-col gap-3 py-2">
            {loanFeaturesData.features.map((item) => (
              <div key={item.id} className="flex gap-2">
                <div className="flex min-w-[170px] sm:min-w-[120px]">
                  {item.icon && (
                    <Image
                      src={item.icon}
                      alt={item.label}
                      width={24}
                      height={24}
                      priority={true}
                      className="mr-1 sm:w-3 sm:h-3"
                    />
                  )}
                  <span className="text-base2 text-baseBlack font-medium sm:text-xs">
                    {item.label}
                  </span>
                </div>
                <p
                  className={`text-baseBlack font-medium text-base2 sm:text-xs text-left w-full ${
                    item.id === 0 ? "" : "border-b border-[#F4D99A]"
                  }`}
                >
                  {item.value}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default LoanFeatures;
